import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=442bc67a&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=442bc67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442bc67a",
  null
  
)

export default component.exports